import { render, staticRenderFns } from "./MetadataDrawerPlugin.vue?vue&type=template&id=09728845&scoped=true"
import script from "./MetadataDrawerPlugin.vue?vue&type=script&lang=js"
export * from "./MetadataDrawerPlugin.vue?vue&type=script&lang=js"
import style0 from "./MetadataDrawerPlugin.vue?vue&type=style&index=0&id=09728845&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09728845",
  null
  
)

export default component.exports